import clsx from "clsx";

export interface Props<T> {
  options:
    | {
        key: T;
        label: React.ReactNode;
      }[]
    | readonly {
        key: T;
        label: React.ReactNode;
      }[];
  current: T;
  onClick: (key: T) => unknown;
  size?: "small" | "normal";
  highlightColor?: "primary" | "secondary";
  className?: string;
}

function ButtonSwitch<T>({
  options,
  current,
  onClick,
  size = "normal",
  highlightColor = "primary",
  className,
}: Props<T>) {
  return (
    <div className={className}>
      {options.map((opt, i) => (
        <button
          key={i}
          onClick={() => onClick(opt.key)}
          aria-pressed={current === opt.key}
          className={clsx(
            size === "normal" ? "py-2 px-3 m-0" : "py-1 px-2 m-0 text-sm",
            "border",
            "rounded-l-none",
            "rounded-r-none",
            "first:rounded-l",
            "last:rounded-r",
            "border-r-0",
            "last:border-r",
            highlightColor === "primary" && "border-primary-main",
            highlightColor === "secondary" && "border-secondary-main",
            highlightColor === "primary"
              ? current === opt.key
                ? "bg-primary-main hover:bg-primary-dark text-primary-contrastText"
                : "hover:text-primary-main"
              : current === opt.key
              ? "bg-secondary-main hover:bg-secondary-dark text-secondary-contrastText"
              : "hover:text-secondary-dark"
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default ButtonSwitch;
